import $ from 'jquery'
import _ from 'lodash'
import axios from 'axios'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import attributes from '../../settings/references.json'
import {
    logoutFromSSO,
    updateIframeStyles,
    addRememberAccountCheckbox,
    correctOpenLinks,
    checkIfEULA,
} from './sso-commands'
import Button from '../Button'
import styles from './login-window.scss'

class LoginWindow extends Component {
    constructor(props) {
        super(props)

        this.iframe = undefined
        this.iframeURL = undefined
        this.account = { remember: false }
    }

    componentDidMount() {
        this.refreshLoginWindow()
    }

    componentDidUpdate(prevProps) {
        this.refreshLoginWindow(prevProps)
    }

    getSsoUrl = () => {
        if (
            this.props.server == null ||
            _.isEmpty(this.props.server) ||
            this.props.language == null ||
            this.props.server.sso == null ||
            this.props.server.sso.url == null
        ) {
            return ''
        }

        // Get the login url for the SSO
        let loginUrl = attributes.service.sso.login

        // Check if we should add the steam parameter to the url
        if (this.props.steam.steamStartup && !this.props.steam.hasLoggedIn) {
            // Add steam path to url
            loginUrl += attributes.service.sso.steam
        }

        // Return the login url with the correct parameters
        return loginUrl
            .replace(/{host}/gi, this.props.server.sso.url)
            .replace('{locale}', this.props.language)
            .replace('{steamTicket}', this.props.steam.steamTicket)
    }

    refreshLoginWindow = (prevProps, hide = false) => {
        // If there is no active server, then do nothing
        if (this.props.server == null || _.isEmpty(this.props.server)) {
            return
        }

        let updateWindow = false

        if (prevProps == null || prevProps.server == null) {
            updateWindow = true
        } else if (prevProps.server.shortName !== this.props.server.shortName) {
            updateWindow = true
        } else if (prevProps.server.sso.url !== this.props.server.sso.url) {
            updateWindow = true
        }

        if (prevProps != null && prevProps.language !== this.props.language) {
            updateWindow = true
        }

        if (updateWindow) {
            try {
                logoutFromSSO(this.props.server.sso.url, '', this.getSsoUrl(), $('#sso-frame'))

                if (hide) {
                    this.props.displayLoginWindow(false)
                    this.props.onReady('loading')
                } else {
                    this.loadSingleSignOnFrame()
                }
            } catch (error) {
                console.info(`Could not update SSO iframe: ${error.message}`)
            }
        }
    }

    loadSingleSignOnFrame = () => {
        // Retrieve the SSO iframe
        this.iframe = $('#sso-frame')

        // When the SSO reloads we perform this check
        $('#sso-frame').on('load', (event) => {
            try {
                // let $frameContent = this.iframe.contents()
                this.iframeURL = event.currentTarget.contentWindow.location.href

                if (!this.props.steam.steamStartup) {
                    this.props.updateLaunchOnStartup()
                }

                // Watch for changes in the hash
                $(event.currentTarget.contentWindow).on('hashchange', () => {
                    checkIfEULA(
                        $(event.currentTarget),
                        event.currentTarget.contentWindow.location.href,
                        styles.eula,
                    )
                })

                // Inform the parent component that the
                // iframe has loaded
                this.props.onReady('ready')

                // If this is a steam startup, update the state
                if (this.props.steam.steamStartup && !this.props.steam.hasLoggedIn) {
                    this.props.updateSteam()
                }

                // Read the query from our iframe
                const query = queryString.parse(event.currentTarget.contentWindow.location.search)

                // If we have a code in the query we can try logging in
                // with code
                if (query.code !== undefined) {
                    this.refreshLoginWindow(null, true)
                    this.loginWithCode(query.code, this.account.remember)
                    return
                }

                // Add the remember me checkbox
                // To make it work with EULA we added the iframeURL
                addRememberAccountCheckbox(
                    this.iframe,
                    this.iframeURL,
                    this.account,
                    this.props.localize('rememberAccount'),
                    this.props.localize('insecure'),
                )

                // Update the styles of the iframe
                // to match the width of the window
                updateIframeStyles(this.iframe)

                // Update links
                correctOpenLinks(this.iframe)
            } catch (error) {
                this.iframeURL = 'external'

                if (error.message.indexOf('Blocked a frame with origin') !== -1) {
                    // CORS error occurred
                    // Create log line
                    console.info(
                        `Requesting SSO status check because of iframe error during login: ${
                            error.message
                        }`,
                    )
                    // Start a status check
                    this.props.ssoStatusCheck(this.props.server)
                } else {
                    console.info(`Encountered an error while loading the SSO: ${error.message}`)
                }
            }
        })
    }

    loginWithCode = (code, rememberAccount) => {
        if (this.props.server.sso.slinger === undefined) {
            throw Error(`Token service for ${this.props.server.name} is undefined`)
        }

        // Generate the source
        const source = attributes.service.slinger.verify.replace(
            '{host}',
            this.props.server.sso.slinger,
        )

        // Send the code to the token service and retrieve
        // the token/user information
        axios({
            method: 'post',
            url: source,
            data: {
                token: code,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                this.loginUser(response.data, rememberAccount)
            })
            // Logout from SSO
            .then(() => {
                logoutFromSSO(
                    this.props.server.sso.url,
                    this.iframeURL,
                    this.getSsoUrl(),
                    this.iframe,
                )
            })
            .catch((error) => {
                // Commonly used error message
                const commonErrorMessage = 'Could not finish login of user with code:'

                // Handle the type of error we're encountering
                if (error.response == null && error.message === 'Network Error') {
                    // No connection could be established
                    console.info(
                        `${commonErrorMessage} Request failed, could not connect to ${source}`,
                    )
                } else if (error.response != null) {
                    // Error reported from the token service
                    const statusText = error.response.statusText
                    console.info(`${commonErrorMessage} ${error.message} ${statusText}`)
                } else {
                    // Other errors
                    console.info(`${commonErrorMessage} ${error.message}`)
                }

                // Display error message
                this.props.displayError(this.props.localize('error_loginUser'))
                this.props.onReady('ready')

                // Logout from SSO to display login window again
                logoutFromSSO(
                    this.props.server.sso.url,
                    this.iframeURL,
                    this.getSsoUrl(),
                    this.iframe,
                )
            })
    }

    loginUser = (ssoUser, rememberAccount) => {
        if (ssoUser.HashedUserID == null || ssoUser.UserName == null) {
            const errorType = ssoUser.HashedUserID == null ? 'Hashed ID' : 'Username'
            throw Error(`${errorType} was not properly set for loginUser object`)
        }

        // Create the new user object
        const user = {
            hash: ssoUser.HashedUserID,
            username: ssoUser.UserName,
            profile: 'Default',
            remember: rememberAccount,
            multiLaunch: false,
            autoLaunch: this.props.autoLaunch,
            tokens: {
                accessToken: ssoUser.AccessToken,
                refreshToken: ssoUser.RefreshToken,
            },
        }

        this.props.loginUser(user)
        this.props.displayLoginWindow(false)
    }

    render() {
        // If there is no active server, then do nothing
        if (this.props.server == null || _.isEmpty(this.props.server)) {
            return null
        }

        const displayCancelButton = this.props.showCancel ? (
            <Button className="btn" secondary onClick={() => this.props.displayLoginWindow(false)}>
                {this.props.localize('cancel')}
            </Button>
        ) : (
            ''
        )
        const ssoUrl = this.getSsoUrl()
        return (
            <div>
                <iframe
                    id="sso-frame"
                    title="sso-frame"
                    className={styles.ssoFrame}
                    scrolling="no"
                    src={ssoUrl}
                />
                {displayCancelButton}
            </div>
        )
    }
}

LoginWindow.propTypes = {
    server: PropTypes.shape({
        enabled: PropTypes.bool,
        name: PropTypes.string,
        numPlayers: PropTypes.number,
        playButton: PropTypes.bool,
        shortName: PropTypes.string,
        showPlayers: PropTypes.bool,
        sso: PropTypes.shape({
            slinger: PropTypes.string,
            url: PropTypes.string,
        }),
        status: PropTypes.string,
        statusLabel: PropTypes.string,
        websiteUrl: PropTypes.string,
    }),
    autoLaunch: PropTypes.bool,
    steam: PropTypes.shape({
        hasLoggedIn: PropTypes.bool,
        steamStartup: PropTypes.bool,
        steamTicket: PropTypes.string,
        usedTicket: PropTypes.string,
    }),
    language: PropTypes.string,
    showCancel: PropTypes.bool,
    loginUser: PropTypes.func,
    updateSteam: PropTypes.func,
    onReady: PropTypes.func,
    displayLoginWindow: PropTypes.func,
    ssoStatusCheck: PropTypes.func,
    localize: PropTypes.func,
    displayError: PropTypes.func,
    updateLaunchOnStartup: PropTypes.func,
}

export default LoginWindow



// WEBPACK FOOTER //
// ./src/components/LoginWindow/login-window.js